<template>
    <v-container fluid class="pa-0 px-3">

        <v-row class="align-center mb-3 pt-4 pl-3">
            <v-btn @click="backHandler" color="orange" class="white--text mr-3">
                {{$t('button.back')}}
            </v-btn>
        </v-row>

                

                <!-- <v-container
                    fluid
                    id="scroll-target"
                    class="custom-form overflow-y-auto px-5"
                > -->

                <v-row>
                    <v-col cols="12"> 
                    <v-card v-if="!loading && hide" elevation="5" outlined >
                        <apexchart ref="barchartcompany" type="bar"  width="100%" :options="companyChartOptions" :series="series"></apexchart>
                    </v-card>
                    </v-col>

                    <v-col cols="12" > 
                    <v-card v-if="!hide" elevation="5" outlined >
                        <apexchart  ref="barchartdepartment" type="bar" width="100%" :options="departmentChartOptions" :series="seriesDepartment"></apexchart>
                    </v-card>
                    </v-col>
                    
                    <v-col cols="6">
                        <v-card v-if="hide" elevation="5" outlined> 
                            <v-card-title class="pie-chart-title">{{ $t('reportheadcountanalysis.overallheadcountdistributionbygender') }}</v-card-title>
                            <apexchart ref="piechart" type="donut" width="100%" height="380" :options="genderChartOptions" :series="pieseries"></apexchart>
                        </v-card>
                    </v-col>

                    <v-col cols="6">
                        <v-card v-if="hide" elevation="5" outlined> 
                            <v-card-title class="pie-chart-title">{{ $t('reportheadcountanalysis.overallheadcountdistributionbynationality') }}</v-card-title>
                            <apexchart ref="donuchart" type="donut" width="100%" height="380" :options="nationalityChartOptions" :series="donutseriesNationality"></apexchart>
                        </v-card>
                    </v-col>
                </v-row>
                <div class="mb-4"></div>

                <div class="row" v-if="!hidetable">
                    <div class="col-sm-12">

                        <v-toolbar>
                            <v-toolbar-title style="height: 50px; float: left; margin-top: 20px; margin-left:20px" class="textBlue">
                                {{ title }}
                            </v-toolbar-title>
                        
                        <v-spacer></v-spacer>
                        <button type="button" class="export-icon-btn export-icon-pdf" @click="printPDF" title="Export PDF"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><path d="M9 13h2a2 2 0 0 1 0 4H9v-4z"/><path d="M15 13h1a2 2 0 0 1 0 4h-1"/><line x1="15" y1="17" x2="17" y2="17"/></svg>PDF</button>

                                <button type="button" class="export-icon-btn export-icon-csv" @click="getCSV" title="Export CSV"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="12" y1="18" x2="12" y2="12"/><polyline points="9 15 12 18 15 15"/></svg>CSV</button>

                        </v-toolbar>

                        
                        
                    </div>
                </div>

                <div class="row" v-if="!hidetable">
                    <div class="col-sm-12 mt-n8">

                        <div style="overflow-x: auto; width: 100%;">
        <v-data-table
                            :headers="headers"
                            :items="staffdetails"
                            :options.sync="options"
                            class="elavation-1 fixed header"
style="margin-top: 20px"
                        >
                            <template slot="items" slot-scope="props">
                                
                                <td class="text-xs-left">{{ props.item.psnname }}</td>
                                <td class="text-xs-left">{{ props.item.staffcode }}</td>
                                <td class="text-xs-left">{{ props.item.deptname  }}</td>
                                <td class="text-xs-left">{{ props.item.posdesc  }}</td>
                                <td class="text-xs-center">{{ props.item.jobtitle  }}</td>
                                <td class="text-xs-center">{{ props.item.grddesc  }}</td>
                                <td class="text-xs-center">{{ props.item.emptypedesc  }}</td>
                                <td class="text-xs-left">{{ props.item.brchname }}</td>
                                <td class="text-xs-left">{{ props.item.divnname }}</td>
                                <td class="text-xs-center">{{ props.item.sectioname  }}</td>
                                <td class="text-xs-left">{{ props.item.unitname }}</td>
                            </template>
                            <template slot="pageText" slot-scope="props">
                                Rows Per Page {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}
                            </template>
                        </v-data-table>
                    </div>
                    </div>
                </div>
<!-- 
                </v-container> -->
    </v-container>    
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import jsPDF from 'jspdf'
import 'jspdf-autotable' 


export default {
    components: {
        'apexchart': VueApexCharts,
        
    },    

    computed: {
        companyChartOptions() {
            const options = JSON.parse(JSON.stringify(this.chartOptions));

            // 🔴 CRITICAL: restore click handler after cloning
            options.chart = options.chart || {};
            options.chart.events = {
                dataPointSelection: (event, chartContext, config) => {
                    this.drilldown(config.dataPointIndex);
                }
            };

            return options;
        },

        genderChartOptions() {
            return JSON.parse(JSON.stringify(this.piechartOptions));
        },

        nationalityChartOptions() {
            return JSON.parse(JSON.stringify(this.donutchartOptionsNationality));
        },

        departmentChartOptions() {
            const options = JSON.parse(JSON.stringify(this.chartOptionsDepartment));

            options.chart = options.chart || {};
            options.chart.events = {
                dataPointSelection: (event, chartContext, config) => {
                    this.getStaffDetails(config.dataPointIndex);
                }
            };

            return options;
        },
    },

    data() {
        return {
            publicPath: process.env.BASE_URL,
            bar_data_returned: [],
            pie_data_returned: [],
            pie_data_returned_nationality: [],
            dept_data_returned: [],
            staffdetails: [],


            options: {
                page: 1,
                itemsPerPage: 10,
                sortBy: [],
                sortDesc: [],
                groupBy: [],
                groupDesc: [],
                multiSort: false,
                mustSort: false
            },

            // ======================
            // BAR CHART – COMPANY
            // ======================
            chartOptions: {
                chart: {
                    id: 'company-chart',
                    // events: {
                    //     dataPointSelection: (event, chartContext, config) => {
                    //         this.drilldown(config.dataPointIndex);
                    //     }
                    // }
                },
                title: {
                    text: '',
                    align: 'center',
                    margin: 10,
                    style: {
                        fontSize: '16px',
                        color: '#004080',
                        fontWeight: '400',
                        fontFamily: 'Lato-Bold'
                    }
                },
                subtitle: {
                    text: '',
                    align: 'center',
                    style: {
                        fontSize: '12px',
                        color: 'grey',
                        fontFamily: 'Lato-Bold'
                    }
                },
                legend: { show: false },
                plotOptions: {
                    bar: { distributed: true }
                },
                xaxis: {
                    categories: []
                }
            },

            series: [
                { name: 'Headcount', data: [] }
            ],

            // ======================
            // BAR CHART – DEPARTMENT
            // ======================
            chartOptionsDepartment: {
                chart: {
                    id: 'dept-bar',
                    // events: {
                    //     dataPointSelection: (event, chartContext, config) => {
                    //         this.getStaffDetails(config.dataPointIndex);
                    //     }
                    // }
                },
                title: {
                    text: '',
                    align: 'center',
                    margin: 10,
                    style: {
                        fontSize: '16px',
                        color: 'grey',
                        fontFamily: 'Lato-Bold'
                    }
                },
                subtitle: {
                    text: '',
                    align: 'center',
                    style: {
                        fontSize: '12px',
                        color: '#004080',
                        fontFamily: 'Lato-Bold'
                    }
                },
                legend: { show: false },
                plotOptions: {
                    bar: { distributed: true }
                },
                xaxis: {
                    categories: []
                }
            },

            seriesDepartment: [
                { data: [] }
            ],

            // ======================
            // PIE CHART – GENDER
            // ======================
            pieseries: [],
            piechartOptions: {
                chart: {
                    type: 'pie',
                    toolbar: {
                        show: true,
                        tools: {
                            download: true,
                            selection: true,
                            zoom: true,
                            zoomin: true,
                            zoomout: true,
                            pan: true,
                            reset: true
                        },
                        export: {
                            csv: { filename: '' },
                            svg: { filename: '' },
                            png: { filename: '' }
                        }
                    }
                },
                title: {
                    text: '',
                    align: 'center',
                    margin: 20,
                    style: {
                        fontSize: '14px',
                        color: '#004080',
                        fontFamily: 'Lato-Bold'
                    }
                },
                plotOptions: {
                    pie: { customScale: 1 }
                },
                labels: []
            },

            // ======================
            // DONUT CHART – NATIONALITY
            // ======================
            donutseriesNationality: [],
            donutchartOptionsNationality: {
                chart: {
                    type: 'donut',
                    toolbar: {
                        show: true,
                        tools: {
                            download: true,
                            selection: true,
                            zoom: true,
                            zoomin: true,
                            zoomout: true,
                            pan: true,
                            reset: true
                        },
                        export: {
                            csv: { filename: '' },
                            svg: { filename: '' },
                            png: { filename: '' }
                        }
                    }
                },
                title: {
                    text: '',
                    align: 'center',
                    margin: 20,
                    style: {
                        fontSize: '14px',
                        color: '#004080',
                        fontFamily: 'Lato-Bold'
                    }
                },
                plotOptions: {
                    pie: { customScale: 1 }
                },
                labels: []
            },

            // ======================
            // TABLE
            // ======================
            headers: [
                    { text: this.$t('columns.name'), value: 'psnname', width: '200px' }, 
                    { text: this.$t('columns.staffcode'), value: 'staffcode', width: '200px' },
                    { text: this.$t('columns.department'), value: 'deptname', width: '200px' },
                    { text: this.$t('columns.position'), value: 'posdesc', width: '200px' },
                    { text: this.$t('columns.job'), value: 'jobtitle', width: '200px' },
                    { text: this.$t('columns.grade'), value: 'grddesc', width: '200px' },
                    { text: this.$t('columns.employmenttype'), value: 'emptypedesc', width: '200px' },
                    { text: this.$t('columns.branch'), value: 'brchname', width: '200px' },
                    { text: this.$t('columns.division'), value: 'divnname', width: '200px' },
                    { text: this.$t('columns.section'), value: 'sectioname', width: '200px' },
                    { text: this.$t('columns.unit'), value: 'unitname', width: '200px' },
            ],

            isErr: false,
            loading: true,
            hide: true,
            hidetable: true,

            title: '',

            compnyid: '',
            compnyname: '',
            departmentid: '',
            departmentname: ''
        };
    },
 
    methods: {

        //load bar chart - headcount distribution by company
        async companychart() {
            const vm = this;

            try {
                // update title immutably
                vm.chartOptions = {
                    ...vm.chartOptions,
                    title: {
                        text: this.$t('reportheadcountanalysis.headcountanalysisbycompanyasat') + vm.asatdate,
                        align: 'center',
                        margin: 10,
                        style: {
                            fontsize: '16px',
                            color: ' #004080'
                        }
                    }
                };

                const res = await this.$store.dispatch('get', {
                    url: "/headcountdistribution/headcountbycompany/" + vm.asatdate
                });

                const apiData = res.data.rec || [];

                // 🔴 REQUIRED FOR CLICK DRILLDOWN
                vm.bar_data_returned = apiData;

                const categories = [];
                const data = [];

                apiData.forEach(element => {
                    categories.push(element.company_name);
                    data.push(element.total_company);
                });

                // IMMUTABLE update for x-axis
                vm.chartOptions = {
                    ...vm.chartOptions,
                    xaxis: {
                        ...(vm.chartOptions.xaxis || {}),
                        categories: categories
                    }
                };

                // IMMUTABLE update for series
                vm.series = [{
                    name: 'Headcount',
                    data: data
                }];

                vm.loading = false;

            } catch (err) {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
                throw err;
            }
        },
        
        //load gender dist pie chart 
        async genderchart() {
            const vm = this;

            try {
                const res = await this.$store.dispatch('get', {
                    url: "/headcountdistribution/headcountdistributionbygender/" + vm.asatdate
                });

                const apiData = res.data.rec || [];

                const labels = [];
                const series = [];

                apiData.forEach(element => {
                    labels.push(element.gender_name || 'Unknown');
                    series.push(element.total_gender || 0);
                });

                // IMMUTABLE updates (critical)
                vm.piechartOptions = {
                    ...vm.piechartOptions,
                    labels: labels
                };

                vm.pieseries = series;

            } catch (err) {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
                throw err;
            }
        },

        //load nationality dist. pie chart 
        async nationalitychart() {
            const vm = this;

            try {
                const res = await this.$store.dispatch('get', {
                    url: "/headcountdistribution/headcountdistributionbynationality/" + vm.asatdate
                });

                const apiData = res.data.rec || [];

                const labels = [];
                const series = [];

                apiData.forEach(element => {
                    labels.push(element.nationality_name || 'Unknown');
                    series.push(element.total_nationality || 0);
                });

                // IMMUTABLE updates (critical)
                vm.donutchartOptionsNationality = {
                    ...vm.donutchartOptionsNationality,
                    labels: labels
                };

                vm.donutseriesNationality = series;

            } catch (err) {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
                throw err;
            }
        },

        //drill down to dept chart
        async drilldown(dataPointIndex) {
            try {
                const vm = this;

                const company = vm.bar_data_returned[dataPointIndex];
                if (!company) return;

                vm.compnyid = company.companyid;
                vm.compnyname = company.company_name;

                // update title immutably
                vm.chartOptionsDepartment = {
                    ...vm.chartOptionsDepartment,
                    title: {
                        text: this.$t('reportheadcountanalysis.headcountasat') + vm.asatdate,
                        align: 'center',
                        margin: 10,
                        style: {
                            fontsize: '16px',
                            color: 'grey'
                        }
                    },
                    subtitle: {
                        text: vm.compnyname,
                        align: 'center',
                        margin: 10,
                        style: {
                            fontsize: '100px',
                            color: ' #004080'
                        }
                    }
                };

                const res = await vm.$store.dispatch('get', {
                    url: "/headcountdistribution/headcountbydepartment/" + vm.compnyid + "/" + vm.asatdate
                });

                const apiData = res.data.rec || [];
                // 🔴 REQUIRED FOR SECOND CLICK
                vm.dept_data_returned = apiData;

                const categories = [];
                const data = [];

                apiData.forEach(element => {
                    categories.push(element.department_name);
                    data.push(element.total_department);
                });

                // immutable x-axis update
                vm.chartOptionsDepartment = {
                    ...vm.chartOptionsDepartment,
                    xaxis: {
                        ...(vm.chartOptionsDepartment.xaxis || {}),
                        categories: categories
                    }
                };

                // immutable series update
                vm.seriesDepartment = [{
                    data: data
                }];

                // DO NOT DESTROY ANY CHART
                vm.hide = false;
                vm.loading = false;

            } catch (err) {
                this.isErr = true;
                this.errMsg = err;
                this.$emit("error", { isErr: this.isErr, errMsg: this.errMsg });
                throw err;
            }
        },

        //get staff details for department
        getStaffDetails(dataPointIndex){
                
            console.log("datareturneddept", this.dept_data_returned[dataPointIndex].departmentid)

            //get deptid
            this.departmentid = this.dept_data_returned[dataPointIndex].departmentid;
            this.departmentname = this.dept_data_returned[dataPointIndex].department_name;

            const vm = this;

            //pass asatdate & compnyid & deptid as params 
            this.$store.dispatch('get', {url: "/headcountdistribution/staffdetails/" + vm.asatdate + "/" + vm.compnyid + "/" + vm.departmentid})
            .then(res => {

            vm.staffdetails = res.data.rec;

            vm.title = this.$t('reportheadcountanalysis.stafflistfor') + vm.departmentname; 

            //show table 
            vm.hidetable = false;
            vm.loading = false; 
            
            })
            .catch(err => {
                //error - unsucessfull request
                this.isErr = true;
                this.errMsg = err;
                this.$emit("error", { isErr: this.isErr, errMsg: this.errMsg });
            });

        },

        // functions for print to pdf and export to csv
        objectToCSV(data) {
            const csvRows = []

            // get header
            const headers = Object.keys(data[0])
            csvRows.push(headers.join(','))

            // loop over the rows
            for (const row of data) {
                const values = headers.map(header => {
                    const escaped = ('' + row[header]).replace(/"/g, '\\"')
                    return `"${escaped}"`
                })
                csvRows.push(values.join(','))
            }
            return csvRows.join('\n')
        },

        download(data) {
            const blob = new Blob([decodeURIComponent('%ef%bb%bf'), data], { type: 'text/csv'})
            const url = window.URL.createObjectURL(blob)
            const a = document.createElement('a')

            a.setAttribute('hidden', '')
            a.setAttribute('href', url)
            a.setAttribute('download', this.title + '.csv')

            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
        },

        async getCSV() {
            let item = this.staffdetails
            let data = []

            for (var i = 0; i < item.length; i++) {
                
                data.push({
                    [this.$t('columns.name')]: item[i].psnname,
                    [this.$t('columns.staffcode')]: item[i].staffcode,
                    [this.$t('columns.company')]: item[i].compnyname,
                    [this.$t('columns.department')]: item[i].deptname ,
                    [this.$t('columns.position')]: item[i].posdesc,
                    [this.$t('columns.job')]: item[i].jobtitle,
                    [this.$t('columns.grade')]: item[i].grddesc,
                    [this.$t('columns.employmenttype')]: item[i].emptypedesc,
                    [this.$t('columns.branch')]: item[i].brchname,
                    [this.$t('columns.division')]: item[i].divnname,
                    [this.$t('columns.section')]: item[i].sectioname,
                    [this.$t('columns.unit')]: item[i].unitname,
                })
            }

            const csvData = this.objectToCSV(data)
            this.download(csvData)
        },

        printPDF() {
            const doc = new jsPDF({
                orientation: 'landscape'
            })
            let item = this.staffdetails

            console.log("item", item)

            var head = [                
                { title: this.$t('columns.name'), dataKey: 'psnname' },
                { title: this.$t('columns.staffcode'), dataKey: 'staffcode' },
                { title: this.$t('columns.company'), dataKey: 'compnyname' },
                { title: this.$t('columns.department'), dataKey: 'deptname' },
                { title: this.$t('columns.position'), dataKey: 'posdesc' },
                { title: this.$t('columns.job'), dataKey: 'jobtitle' },
                { title: this.$t('columns.grade'), dataKey: 'grddesc' },
                { title: this.$t('columns.employmenttype'), dataKey: 'emptypedesc' },
                { title: this.$t('columns.branch'), dataKey: 'brchname' },
                { title: this.$t('columns.division'), dataKey: 'divnname' },
                { title: this.$t('columns.section'), dataKey: 'sectioname' },
                { title: this.$t('columns.unit'), dataKey: 'unitname' },
            ]

            let body = []

            for (var i = 0; i < item.length; i++) {
               
                body.push({
                        psnname: item[i].psnname,
                        staffcode: item[i].staffcode,
                        compnyname: item[i].compnyname,
                        deptname: item[i].deptname,
                        posdesc: item[i].posdesc,
                        jobtitle: item[i].jobtitle,
                        grddesc: item[i].grddesc,
                        emptypedesc: item[i].emptypedesc,
                        brchname: item[i].brchname,
                        divnname: item[i].divnname,
                        sectioname: item[i].sectioname,
                        unitname: item[i].unitname
                    })
            }

            console.log('title', this.title)
            this.title = this.$t('reportheadcountanalysis.stafflistfor') + this.departmentname + '" ' + this.$t('reportleavedashboard.asat') + ' "' + this.asatdate ;
            doc.text(this.title, 10, 10) 
            doc.autoTable(head, body)
            doc.save(this.title + '.pdf')
        }, 

        //back handler - go back to parameterHeadcount.vue
        backHandler(){
            this.$router.push({name: 'parameterheadcount'});
        }


        
    },

    async mounted() {
        this.asatdate = this.$route.params.asatdate;
        await this.companychart();
        await this.genderchart();
        await this.nationalitychart();
    }
    
}
</script>

<style scoped>
.textBlue {
    color:  #004080;
}
.hc-main-card {
    background: #ffffff;
    border-radius: 16px;
    border: 1px solid #E8EDF5;
    box-shadow: 0 2px 8px rgba(0,0,0,0.06);
    padding: 16px 16px 24px 16px;
    margin-bottom: 24px;
}
.pie-chart-title {
    font-size: 0.88rem !important;
    font-weight: 600 !important;
    color: #1a3a5c !important;
    letter-spacing: normal !important;
    padding: 12px 16px 4px 16px !important;
    border-bottom: 1px solid #F1F5F9;
}
</style>